<template>
  <div class="text-block pb-16 pt-6">
    <div class="mx-auto w-full max-w-screen-xl container">
      <VcTypography :tag="heading" class="mb-3">{{ title }}</VcTypography>
      <div v-html-safe="contentValue" class="block-content text-lg"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

export interface IProps {
  heading: string;
  title: string;
  background?: string;
  text: string | { html: string };
}

const props = defineProps<IProps>();

const contentValue = computed(() => {
  return typeof props.text === "object" ? props.text?.html : props.text;
});
</script>

<style lang="scss">
.text-block {
  .block-content {
    p {
      margin-bottom: 1.5rem;
    }

    ul {
      list-style: disc inside;
      margin-bottom: 1.5rem;
    }

    a {
      font-weight: bold;
    }
  }

  &.bg-neutral-800 {
    color: white;
  }
}
</style>
